import EngineModule from '../EngineModule';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'header-viewer',
	dependencies :     [
		'oms-basket'
	],
	allowedCustomers : null,
	generateComponentConfiguration() {
		return {};
	},
	insertionPath : null
});
